import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { NgxUploaderModule } from 'ngx-uploader';
import { AuthService } from '../auth/services/auth.service';
import { TokenInterceptor } from '../auth/token.interceptor';
import { SharedModule } from '../shared/shared.module';
import { EndPointService } from './services/end-point.service';


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    SharedModule,
    NgxUploaderModule
  ],
  providers: [
    EndPointService
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        { provide: 'Window', useValue: window },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        AuthService
      ]
    };
  }
}


